<!-- Copyright (c) 2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="logo-container">
    <img height="64" src="../../../assets/cigent-logo-mini.png" alt="Cigent Logo">
</div>

<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{'integrations.testing.device_name' | translate}}</mat-label>
                <input autocomplete="off" matInput name="device_name" id="device_name" type="search" formControlName="device_name" placeholder="{{'integrations.testing.device_name_placeholder' | translate}}" maxlength="36">
            </mat-form-field>
        </div>
        <div>
            <mat-slide-toggle class="field-toggle" id="send_at_start" formControlName="send_at_start">{{'integrations.testing.send_at_start' | translate}}</mat-slide-toggle>
        </div>
        <div>
            <mat-slide-toggle class="field-toggle" id="send_every_loop" formControlName="send_every_loop">{{'integrations.testing.send_every_loop' | translate}}</mat-slide-toggle>
        </div>

        <div class="section">
            <mat-radio-group [formControl]="formGroup.controls.lock_option" aria-label="Select what happens when a threat is received.">
                <div>
                    <mat-radio-button id='device_only' value="device_only">{{'integrations.device_only' | translate}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button id='device_sets' value="device_sets">{{'integrations.device_sets' | translate}}</mat-radio-button>
                </div>
                <div>
                    <mat-radio-button id='all_devices' value="all_devices">{{'integrations.all_devices' | translate}}</mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <button type="button" (click)="cancel()" mat-raised-button id="integrationCancel">{{'CANCEL' | translate}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button id="integrationSave">{{'SAVE' | translate}}</button>

    </form>
</div>

